<template>
	<div>
		<div :key="'UPLOAD_FILE_' + hack">
			<!-- <div>{{ __("Upload new file:") }}</div> -->

			<form @submit.prevent="submit" class="space-y-4">
				<input type="file" @input="form.file = $event.target.files[0]" />
				<ui-validation-message :form="form" field="file" />
				<progress
					v-if="form.progress"
					:value="form.progress.percentage"
					max="100"
				>
					{{ form.progress.percentage }}%
				</progress>

				<div class="flex space-x-4 items-end">
					<ui-select-group
						v-model="labelOption"
						class="flex-grow"
						field="type"
						type="select"
						label="Description"
						:options="labelOptions"
						:form="form"
						:required="true"
					></ui-select-group>
					<ui-input-group
						v-if="labelOption == null"
						class="col-span-2"
						v-model="form.label_id"
						field="label_id"
						label="Please insert description"
						:form="form"
						:required="true"
					></ui-input-group>
				</div>
				<ui-button v-on:click="submit()">{{ __("Upload") }}</ui-button>
			</form>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		form: {
			type: Object,
			required: true,
		},
		uploads: {
			type: Array,
			required: false,
			default: null,
		},
		iframeModal: {
			type: Boolean,
			default: false,
		},
		labelOptions: {
			type: Array,
			required: false,
		},
		threadId: {
			type: Number,
			required: false,
			default: null,
		},
	},
	data() {
		return {
			labelOption: "Wiegenote",
			hack: 0,
		};
	},
	methods: {
		submit() {
			if (this.form.label_id == null) {
				this.form.label_id = this.labelOption;
			}

			let that = this;
			this.form.post(
				this.$route("user.upload", { iframe_modal: this.iframeModal }),
				{
					preserveState: true,
					onSuccess() {
						that.form.reset();
						that.hack++;
						that.$emit("new-upload", this.form);
					},
				}
			);
		},
		showImage(uploadId) {
			return this.$route("user_uploads.download", {
				id: uploadId,
			});
		},
	},
};
</script>
